import { logWrapper } from '../../utils';

export default {
  formsController: [
    'runtimeConstant',
    '$rootScope',
    '$filter',
    'authService',
    'EAdminFeatures',
    'webApiSettings',
    function (
      runtimeConstant,
      $rootScope,
      $filter,
      authService,
      EAdminFeatures,
      webApiSettings
    ) {
      'use strict';

      const showDigitalizationsFeature =
        webApiSettings.viewerServer === 'TESTE' ||
        webApiSettings.viewerServer === 'NOSSO';

      function run() {
        try {
          $rootScope.menus = [
            {
              title: $filter('translate')('CONTRACTS'),
              icon: 'md md-view-headline',
              ref: 'modules.forms.contracts',
              visible: function () {
                return authService.isSysAdmin();
              },
              enabled: true,
            },
            {
              title: $filter('translate')('COMPANIES'),
              icon: 'md md-domain',
              ref: 'modules.forms.companies',
              visible: function () {
                return authService.isSysAdmin();
              },
              enabled: true,
            },
            {
              title: 'REPOSITORIES',
              icon: 'md md-inbox',
              ref: 'modules.forms.repositories',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ManageRepositories],
              enabled: true,
            },
            {
              title: 'DOCUMENT TYPES',
              icon: 'md md-filter-none',
              ref: 'modules.forms.documentTypes',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ManageDocumentTypes],
              enabled: true,
            },
            {
              title: 'ADDITIONAL FIELDS',
              icon: 'md md-add',
              ref: 'modules.forms.additionalFields',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ManageAdditionalFields],
              enabled: true,
            },
            {
              title: 'LISTS',
              icon: 'md md-format-list-bulleted',
              ref: 'modules.forms.lists',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ManageDataLists],
              enabled: true,
            },
            {
              title: 'SYSTEM CONFIGS',
              icon: 'md md-brightness-low',
              ref: 'modules.forms.systemConfiguration',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ConfigureSystemOptions],
              enabled: true,
            },
            {
              title: 'PERSONALIZATION',
              icon: 'md md-edit',
              ref: 'modules.forms.personalization',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ConfigureSystemOptions],
              enabled: true,
            },
            {
              title: 'DIGITALIZATIONS',
              icon: 'md md-local-print-shop',
              ref: 'modules.forms.digitalizacoes',
              visible: function () {
                return authService.verifyHasAdminFeature() && showDigitalizationsFeature;
              },
              features: [EAdminFeatures.ConfigureSystemOptions],
              isNew: true,
              enabled: true,
            },
          ];
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
